var CryptoJS = require("crypto-js");

const passphrase = "dure@techno";

var AesUtil = function (keySize, iterationCount) {
  this.keySize = keySize / 32;
  this.iterationCount = iterationCount;
};

AesUtil.prototype.generateKey = function (salt, passPhrase) {
  var key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
    keySize: this.keySize,
    iterations: this.iterationCount,
    hasher: CryptoJS.algo.SHA1,  // hasher required due to node compatibility issue, otherwise api throws 403 unauthorized error
  });
  return key;
};

AesUtil.prototype.encrypt = function (salt, iv, plainText) {
  var key = this.generateKey(salt, passphrase);

  var encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

AesUtil.prototype.decrypt = function (salt, iv, cipherText) {
  var key = this.generateKey(salt, passphrase);
  var cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText),
  });
  var decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

AesUtil.prototype.generateSalt = function () {
  var salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  return salt;
};

AesUtil.prototype.generateiv = function () {
  var iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  return iv;
};

module.exports = AesUtil;
